import { UnitUsageType } from 'models/UnitUsageType';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const UnitUsageTypeActionType = {
    FETCH_UNITUSAGETYPES: 'FETCH_UNITUSAGETYPES',
    FETCH_UNITUSAGETYPES_SUCCESS: 'FETCH_UNITUSAGETYPES_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchUnitUsageTypesAction {
    type: typeof UnitUsageTypeActionType.FETCH_UNITUSAGETYPES
    payload: ApiPayload,
    returnPayload: UnitUsageType[],
    meta: {
        isApiCall: boolean
    },
}

export type IUnitUsageTypeActions = IFetchUnitUsageTypesAction

const baseUrl = 'api/units/usage';
export class UnitUsageTypeActions {
    public static fetchUnitUsageTypes(token: string): IUnitUsageTypeActions {
        return {
            type: UnitUsageTypeActionType.FETCH_UNITUSAGETYPES,
            payload: Api.fetchApiCall(baseUrl, token, UnitUsageTypeActionType.FETCH_UNITUSAGETYPES_SUCCESS, UnitUsageTypeActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }
}